import { render, staticRenderFns } from "./DevModelList.vue?vue&type=template&id=0110232c&scoped=true&"
import script from "./DevModelList.vue?vue&type=script&lang=js&"
export * from "./DevModelList.vue?vue&type=script&lang=js&"
import style0 from "./DevModelList.vue?vue&type=style&index=0&id=0110232c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0110232c",
  null
  
)

export default component.exports